import { Routes, Route } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import Loader from '../sales_marketing/component/Loader';
import MobilityVoucherDashboardPage from './page/Dashboard/MobilityVoucherDashboardPage';
import MobilityVoucherOrders from './page/Order/MobilityVoucherOrders';
import MobilityVoucherNewOrder from './page/Order/MobilityVoucherNewOrder';
import MobilityVoucherDetailsOrder from './page/Order/MobilityVoucherDetailsOrder';
import { useHasScope } from '../../config/globalConfig';
import MobilityVoucherPaymentOrder from './page/Order/MobilityVoucherPaymentOrder';
import SuccessPayment from './page/Order/Stepper/SuccessPayment';
import ErrorPayment from './page/Order/Stepper/ErrorPayment';

//TODO Aggiungere rotte da pages

const MobilityVoucherMain = () => {
    const hasScope = useHasScope;

    if (!hasScope('SCOPE_MOBILITY_VOUCHER')) {
        return null;
    }

  return (
      <RecoilRoot key='mobilityvoucher'>
          <Routes>
            {hasScope('SCOPE_MV_DASHBOARD') &&
              <Route path="/dashboard" element={
                  <MobilityVoucherDashboardPage/>
              }/>
            }
            {hasScope('SCOPE_MV_ORDERS_VIEW') &&
                <Route path="/orders" element={
                  <MobilityVoucherOrders/>
              }/>
            }
              <Route path="/new-order" element={
                  <MobilityVoucherNewOrder/>
              }/>
              <Route path="/details-order/:id" element={
                  <MobilityVoucherDetailsOrder/>
              }/>
               <Route path="/payment-order" element={
                  <MobilityVoucherPaymentOrder/>
              }/>
              <Route path="/payment-order/success-payment" element={
                  <SuccessPayment/>
              }/>
              <Route path="/payment-order/error-payment" element={
                  <ErrorPayment/>
              }/>
          </Routes>
          <Loader/>
      </RecoilRoot>
  );
}

export default MobilityVoucherMain;